import {
  ReactNode,
  Suspense,
  lazy,
  useState,
  cloneElement,
  isValidElement,
} from "react";
import { trackViewForm } from "@/lib/analytics";

const Dialog = lazy(() =>
  import("@/components/ui/dialog").then((m) => ({ default: m.Dialog })),
);
const DialogContent = lazy(() =>
  import("@/components/ui/dialog").then((m) => ({ default: m.DialogContent })),
);

const HeroQuoteForm = lazy(() =>
  import("./HeroQuoteForm").then((m) => ({ default: m.HeroQuoteForm })),
);

export function QuoteModal({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  const handleOpen = () => {
    setHasInteracted(true);
    setIsOpen(true);
    // GA4 engagement event (not a lead) when the quote modal is opened.
    trackViewForm({ form_id: "HERO FORM 2.0", form_name: "HERO FORM 2.0" });
  };

  const trigger = isValidElement(children) ? (
    cloneElement(children as React.ReactElement<any>, { onClick: handleOpen })
  ) : (
    <span onClick={handleOpen}>{children}</span>
  );

  return (
    <>
      {trigger}
      {hasInteracted && (
        <Suspense fallback={null}>
          <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent className="sm:max-w-lg max-h-[92vh] overflow-y-auto bg-transparent border-none shadow-none p-0 [&>button]:text-white [&>button]:hover:text-white/80 [&>button]:right-4 [&>button]:top-4 [&>button]:z-50 [&>button:hover]:bg-white/10">
              <Suspense
                fallback={
                  <div className="min-h-[460px] flex items-center justify-center bg-[#0B1F3D] rounded-3xl">
                    <div className="w-8 h-8 border-2 border-[#D4A84B] border-t-transparent rounded-full animate-spin" />
                  </div>
                }
              >
                <HeroQuoteForm />
              </Suspense>
            </DialogContent>
          </Dialog>
        </Suspense>
      )}
    </>
  );
}
